import { Header as HeaderComponent } from 'components/Header/Header';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getRecipient } from 'selectors';

type Recipient = {
  name: string;
  website: string;
  logoUrl: string;
};

type Props = {
  recipient: Recipient;
};

const HeaderContainer = ({ recipient: { name, website, logoUrl } }: Props) => (
  <HeaderComponent title={name} subtitle={website} imgUrl={logoUrl} />
);

const mapStateToProps = state => ({
  recipient: getRecipient(state),
});

HeaderContainer.propTypes = {
  recipient: PropTypes.shape({
    name: PropTypes.string,
    logoUrl: PropTypes.string,
    website: PropTypes.string,
  }),
};

const Header = connect(mapStateToProps)(HeaderContainer);

export { Header, HeaderContainer };
